// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

.main-flex-container {
  display: flex;
  flex-direction: column; /* Default to column */
  justify-content: center;
  width: 100%;
  flex-wrap: wrap; /* Allow children to wrap to the next line */
}

/* For larger screens, use row layout */
@media (min-width: 1080px) {
  .main-flex-container {
    flex-direction: row;
  }
}

/* Additional styling for child divs */
.main-flex-container > div {
  margin: 10px;
  width: 100%;
  max-width: 100%; /* Prevent them from growing too large */
}

/* Adjustments for screens larger than 1080px */
@media (min-width: 1080px) {
  .main-flex-container > div {
    width: auto; /* Adjust based on content */
    flex-grow: 1; /* Allow flexible growth */
    max-width: 50%; /* Limit maximum width */
  }
}

/* Media query for medium-sized screens between 1081px and 1500px */
@media screen and (min-width: 1081px) and (max-width: 1500px) {
  .main-flex-container {
    /* Adjust the layout for medium screens */
    flex-direction: row; /* Keep items side by side */
    flex-wrap: wrap; /* Allow items to wrap if necessary */
  }

  .main-flex-container > div {
    width: 40%; /* Adjust width for medium screens */
    flex-grow: 0; /* Prevent flex-grow on medium screens */
    max-width: 40%; /* Ensure maximum width limit */
    margin: 5px; /* Adjust margin for medium screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,aAAa;EACb,sBAAsB,EAAE,sBAAsB;EAC9C,uBAAuB;EACvB,WAAW;EACX,eAAe,EAAE,4CAA4C;AAC/D;;AAEA,uCAAuC;AACvC;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,WAAW;EACX,eAAe,EAAE,wCAAwC;AAC3D;;AAEA,+CAA+C;AAC/C;EACE;IACE,WAAW,EAAE,4BAA4B;IACzC,YAAY,EAAE,0BAA0B;IACxC,cAAc,EAAE,wBAAwB;EAC1C;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,yCAAyC;IACzC,mBAAmB,EAAE,4BAA4B;IACjD,eAAe,EAAE,qCAAqC;EACxD;;EAEA;IACE,UAAU,EAAE,oCAAoC;IAChD,YAAY,EAAE,wCAAwC;IACtD,cAAc,EAAE,+BAA+B;IAC/C,WAAW,EAAE,qCAAqC;EACpD;AACF","sourcesContent":["/* App.css */\n\n.main-flex-container {\n  display: flex;\n  flex-direction: column; /* Default to column */\n  justify-content: center;\n  width: 100%;\n  flex-wrap: wrap; /* Allow children to wrap to the next line */\n}\n\n/* For larger screens, use row layout */\n@media (min-width: 1080px) {\n  .main-flex-container {\n    flex-direction: row;\n  }\n}\n\n/* Additional styling for child divs */\n.main-flex-container > div {\n  margin: 10px;\n  width: 100%;\n  max-width: 100%; /* Prevent them from growing too large */\n}\n\n/* Adjustments for screens larger than 1080px */\n@media (min-width: 1080px) {\n  .main-flex-container > div {\n    width: auto; /* Adjust based on content */\n    flex-grow: 1; /* Allow flexible growth */\n    max-width: 50%; /* Limit maximum width */\n  }\n}\n\n/* Media query for medium-sized screens between 1081px and 1500px */\n@media screen and (min-width: 1081px) and (max-width: 1500px) {\n  .main-flex-container {\n    /* Adjust the layout for medium screens */\n    flex-direction: row; /* Keep items side by side */\n    flex-wrap: wrap; /* Allow items to wrap if necessary */\n  }\n\n  .main-flex-container > div {\n    width: 40%; /* Adjust width for medium screens */\n    flex-grow: 0; /* Prevent flex-grow on medium screens */\n    max-width: 40%; /* Ensure maximum width limit */\n    margin: 5px; /* Adjust margin for medium screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
